import { useLocalizedText } from '../../../hooks/localizedText';
import Modal from '@amzn/awsui-components-react/polaris/modal';
import Box from '@amzn/awsui-components-react/polaris/box';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import Button from '@amzn/awsui-components-react/polaris/button';

export interface DeleteEventModalProps {
  visible: boolean;
  loading?: boolean;
  eventTitle: string;
  attendeeCount: number;
  onConfirm: () => void;
  onDismiss: () => void;
}

export function DeleteEventModal({
  visible,
  loading,
  eventTitle,
  attendeeCount,
  onConfirm,
  onDismiss,
}: DeleteEventModalProps) {
  const { t } = useLocalizedText(['events', 'translation']);
  const hasAttendance = attendeeCount > 0;
  const prefix = hasAttendance ? 'deleteEventWithAttendanceModal' : 'deleteEventModal';

  return (
    <Modal
      visible={visible}
      onDismiss={onDismiss}
      header={t(`${prefix}.title`)}
      closeAriaLabel={t(`${prefix}.closeAriaLabel`)}
      data-testid="delete-event-modal"
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onDismiss}>
              {t(`${prefix}.dismiss`)}
            </Button>
            <Button variant="primary" onClick={onConfirm} loading={loading}>
              {t(`${prefix}.confirm`)}
            </Button>
          </SpaceBetween>
        </Box>
      }
    >
      {hasAttendance
        ? t(`${prefix}.message`, { eventTitle, attendeeCount })
        : t(`${prefix}.message`)}
    </Modal>
  );
}
